// Early-access waitlist event definitions.
// Each event definition is a plain object with a `name` and a TypeScript
// phantom type for its properties, enforced via the EventDefinition generic.

import type { EventDefinition } from './navigation';

export type EarlyAccessWaitlistOpenedProperties = {
  locale: string;
};

// Signup v2 — OTP + X join funnel.

export type WaitlistOtpSentProperties = {
  locale: string;
  /** Partner attribution code attached to the signup, if any. */
  referralCode: string | null;
};

export type WaitlistOtpVerifiedProperties = {
  locale: string;
  referralCode: string | null;
};

export type WaitlistOtpFailedProperties = {
  locale: string;
  reason: 'invalid' | 'expired' | 'too_many_attempts' | 'rate_limited' | 'server' | 'invalid_email';
};

export type WaitlistXStartedProperties = {
  locale: string;
  referralCode: string | null;
};

export type WaitlistXJoinedProperties = {
  locale: string;
  /** False for handle-only joins (X account had no confirmed email). */
  hasEmail: boolean;
};

export const EARLY_ACCESS_WAITLIST_OPENED: EventDefinition<EarlyAccessWaitlistOpenedProperties> = {
  name: 'early_access_waitlist_opened',
};

export const WAITLIST_OTP_SENT: EventDefinition<WaitlistOtpSentProperties> = {
  name: 'waitlist_otp_sent',
};

export const WAITLIST_OTP_VERIFIED: EventDefinition<WaitlistOtpVerifiedProperties> = {
  name: 'waitlist_otp_verified',
};

export const WAITLIST_OTP_FAILED: EventDefinition<WaitlistOtpFailedProperties> = {
  name: 'waitlist_otp_failed',
};

export const WAITLIST_X_STARTED: EventDefinition<WaitlistXStartedProperties> = {
  name: 'waitlist_x_started',
};

export const WAITLIST_X_JOINED: EventDefinition<WaitlistXJoinedProperties> = {
  name: 'waitlist_x_joined',
};
